module.exports = __webpack_public_path__ + "img/Illustration.a7e60ade.png";